import css from './TicketCard.module.scss'
import React, { useCallback, useState } from 'react'
import classNames from 'classnames'

import { getWalletTicketDetailsFromV4Entities } from './Details/adapter'
import TicketCardBase from './Base'
import CardFlipItem from './CardFlipItem'
import TicketCardDetails from './Details'
import { TicketMobileCardProps } from './TicketCardContainer'

const TicketCard: React.FC<TicketMobileCardProps> = (props) => {
  const { baseProps, ticketData, typeTicketData, typeTicketCollectionData } = props

  const { useLongCard, walletEventData, setShowAddExtraBalloon } = baseProps

  const [showDetails, setShowDetails] = useState<boolean>(false)

  const ticketDetails = getWalletTicketDetailsFromV4Entities(
    baseProps.eventData,
    baseProps.locationData,
    ticketData,
    typeTicketData
  )

  const changeShowDetail = useCallback(() => {
    setShowDetails((prevState) => !prevState)
  }, [])

  return (
    <div className={classNames(css.walletTicketCard__flipCard, { [css.long]: useLongCard })}>
      <div className={classNames(css.walletTicketCard__flipCardInner, { [css.details]: showDetails })}>
        <CardFlipItem
          className={css.walletTicketCard__flipCardFront}
          changeShowDetail={changeShowDetail}
          ticketData={ticketData}
          showDetails={showDetails}
          useLongCard={useLongCard}
        >
          <TicketCardBase
            useLongCard={useLongCard}
            setShowAddExtraBalloon={setShowAddExtraBalloon}
            show={!showDetails}
            ticketData={ticketData}
            typeTicketData={typeTicketData}
            typeTicketCollectionData={typeTicketCollectionData}
            walletEventData={walletEventData}
          />
        </CardFlipItem>

        <CardFlipItem
          className={css.walletTicketCard__flipCardBack}
          changeShowDetail={changeShowDetail}
          ticketData={ticketData}
          showDetails={showDetails}
          useLongCard={useLongCard}
        >
          <TicketCardDetails show={showDetails} ticketDetails={ticketDetails} ticketData={ticketData} />
        </CardFlipItem>
      </div>
    </div>
  )
}

export default TicketCard
